module.exports = __webpack_public_path__ + "fonts/SilkSerif-Medium.8421a2d25ff6781bd284e4838d2d0bd4.woff";